export const AUTHORIZATION_HEADER = 'Authorization'
export const TOTAL_COUNT_HEADER = 'x-pagination-total-count'
export const PAGE_COUNT_HEADER = 'x-pagination-page-count'
export const DOCUMENT_DATA_HEADER = 'content-disposition'
export const CONTENT_TYPE = 'content-type'
